import { render, staticRenderFns } from "./ViewOrg.vue?vue&type=template&id=104787c4&scoped=true&"
import script from "./ViewOrg.vue?vue&type=script&lang=js&"
export * from "./ViewOrg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104787c4",
  null
  
)

export default component.exports